import { Button, Radio, Select, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getSatellitesAsync } from "../../../store/reducers/orderSlice";
import { RootState } from "../MapAdapter/store/store";
import { getAOIMetrics } from "./ultis";

const Step1Comp = (props?: any) =>
{

   const { t } = useTranslation();
   const dispatch = useDispatch();
   const allAOI = useSelector((state: RootState) => state.aoi.features);





   const hasSatellite = props?.satellites && props?.satellites.length > 0;

   const isValid =
      !props?.loading &&
      props?.selectedProvider &&
      props?.workflow &&
      (!hasSatellite || (props?.selectedSatellite && props?.selectedSatellite.length > 0)) &&
      allAOI?.length > 0;

   const tooltipMsg = !props?.selectedProvider
      ? t("Please select a provider")
      : props?.satellites?.length > 0 && (!props?.selectedSatellite || props?.selectedSatellite.length === 0)
         ? t("Please select at least one satellite")
         : allAOI?.length === 0
            ? t("Please create a region on the map")
            : !props?.workflow
               ? t("Unsupported provider's schema")
               : "";

   const aoi = allAOI?.[0];
   const metrics = aoi ? getAOIMetrics(aoi) : null;

   const areaKm = metrics ? (metrics.area / 1_000_000).toFixed(2) : null;
   const perimeterKm = metrics ? metrics.perimeter.toFixed(2) : null;



   return (
      <>
         <div className="px-6 pt-6 pb-3">
            <h1 className="text-xl font-semibold">
               {t("Select region & provider")}
            </h1>

            <p className="text-gray-400 text-sm mt-1">
               {t("Step")} 1{props?.totalSteps ? `/${props.totalSteps + 1}` : ""}
            </p>
         </div>

         {/* Provider list */}
         <div className="flex-1 mt-3 overflow-auto px-6 space-y-4">
            {/* <p className="text-xs text-gray-400">CHỌN HÃNG</p> */}

            <Radio.Group
               value={props?.selectedProvider}
               className="w-full space-y-3"
            >
               {props?.allProviders
                  ?.filter((itemF: any) => itemF?.is_active && itemF?.is_tasking)
                  ?.map((p?: any) =>
                  {
                     const active = props?.selectedProvider === p.code;
                     return (
                        <div
                           key={p.id}
                           className={`rounded-xl border p-4 cursor-pointer
      ${active ? "border-blue-500 bg-[#2b3a55]" : "border-[#2a344d] bg-[#1e293b]"}`}
                           onClick={() =>
                           {
                              if (!props?.loading)
                              {
                                 props?.setSelectedProvider(p.code);
                              }
                           }}
                           style={{
                              cursor: !props?.loading ? "pointer" : "not-allowed",
                           }}
                        >
                           <>
                              <Radio value={p.code} className="w-full flex-row-reverse">
                                 <div className="flex items-center gap-3">
                                    <img
                                       src={p.logo_url}
                                       className="w-12 h-12 rounded object-contain bg-white"
                                    />

                                    <div className="flex-1">
                                       <p>{p.name}</p>
                                       <p className="text-xs text-gray-400">
                                          {p.description}
                                       </p>
                                    </div>
                                 </div>
                              </Radio>



                              {active && props?.satellites?.length > 0 && (
                                 <div className="mt-4 space-y-2">
                                    <p className="text-xs text-gray-400 uppercase">
                                       {t("Select Satellite")}
                                    </p>

                                    {/* <Radio.Group
                                       value={props?.selectedSatellite}
                                       onChange={(e) =>
                                       {
                                          if (!props?.loading)
                                             props?.setSelectedSatellite(e.target.value);
                                       }}
                                       className="w-full"
                                    >
                                       {satellites.map((s: any) => (
                                          <Radio
                                             key={s.id}
                                             value={s.id}
                                             className="flex w-full justify-between flex-row-reverse px-3 py-2 hover:bg-[#2a344d] rounded"
                                          >
                                             {s.name}
                                          </Radio>
                                       ))}
                                    </Radio.Group> */}

                                    <Select
                                       mode="multiple"
                                       value={props?.selectedSatellite}
                                       onChange={(value) =>
                                       {
                                          if (!props?.loading)
                                             props?.setSelectedSatellite(value);
                                       }}
                                       placeholder={t("Select satellite")}
                                       className="w-full div-dropdown"
                                       options={props?.satellites.map((s: any) => ({
                                          label: s?.name,
                                          value: s?.name,  // note: backend yêu cầu truyền tên satellite thay vì id
                                       }))}
                                    />
                                 </div>
                              )}
                           </>
                        </div>
                     );
                  })}
            </Radio.Group>

            {/* Polygon info */}
            <div
               className="pb-3 pt-5"
               style={{ borderTop: "1px solid var(--divider-1)" }}
            >
               <p className="text-xs text-gray-400 mb-2 uppercase">
                  {t("Polygon Info")}
               </p>

               <div className="text-sm text-gray-400 space-y-2">
                  <div className="flex justify-between">
                     <span>{t("Perimeter")}</span>
                     <span>
                        {perimeterKm
                           ? `${perimeterKm} km`
                           : t("Please create a region on the map")}
                     </span>
                  </div>

                  <div className="flex justify-between">
                     <span>{t("Area")}</span>
                     <span>
                        {areaKm
                           ? `${areaKm} km²`
                           : t("Please create a region on the map")}
                     </span>
                  </div>
               </div>
            </div>
         </div>

         {/* Footer */}
         <div
            className="flex justify-end px-6  py-4 absolute bottom-0 w-full"
            style={{ borderTop: "1px solid var(--divider-1)" }}
         >
            <Tooltip title={tooltipMsg}>
               <span className="w-[85px] block">
                  <Button
                     onClick={() => props?.onOrder?.()}
                     disabled={!isValid}
                     className="w-[85px] !border-none !bg-[var(--primary-4)] text-[var(--primary-950)]"
                  >
                     {t("Next")}
                  </Button>
               </span>
            </Tooltip>
         </div>
      </>
   );
};

export default Step1Comp;
